import { RootState } from '../rootReducer';
import { TextStrings } from './actions';

export const getTextStringState = (state: RootState): TextStrings => state.textStrings;
